<template>
    <seccion-datos :titulo="estadopendientedatos" @cambios="guardar()">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.nombre') }}</label>
                    <input type="text" class="form-control nombre_completo dato" v-model="nombre_especialidad_pendiente" >
                </div>
            </div>            
        </div>        
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    props: ['id', 'estado_pendiente'],
    data() {
        return {
            nombre_especialidad_pendiente: '',
            estadopendientedatos: "Datos"
        }
    },
    methods: {
        cargardatos() {
            if(this.id==0)return;
            this.nombre_especialidad_pendiente = this.estado_pendiente.nombre;
        },
        async guardar() {
            /* put  modulos/pwgsapi/index.php/bancos/:id */
            const api = new PwgsApi;
            const datos = { nombre_especialidad_pendiente : this.nombre_especialidad_pendiente };
            if (this.id > 0) {
                try {
                    this.$store.dispatch('cambiarGuardando', true);
                    await api.put('tipos-estado-pendiente/' + this.id, datos);
                    this.$parent.obtenerEstadoPendiente(this.id);
                    this.$store.dispatch('cambiarGuardando', false);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    this.$store.dispatch('quitarRuta', this.$route);
                    this.$router.push({name: 'Estados Pendientes'});
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    this.$store.dispatch('cambiarGuardando', false);
                }
            }
            else {
                /* post  modulos/pwgsapi/index.php/bancos */
                try {
                    await api.post('tipos-estado-pendiente/', datos);
                    this.$store.dispatch('quitarRuta', this.$route);
                    this.$router.push({name: 'Estados Pendientes'});
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        comprobar() { }
    },
    mounted() {
        this.cargardatos();
    },
    watch:{
        estado_pendiente(){
            this.cargardatos();
        }   
    }
}
</script>